const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class RavagesOfTime extends Event {
    constructor(){
        super(
            Age.Age2,
            EventNames.RavagesOfTime,
            "Each player chooses one of his or her wonders from Age A or I and turns it face down. These wonders lose all effect and produce 2 culture instead.",
            {}
        )
    }
}

module.exports = RavagesOfTime;